import * as t from "io-ts";
import * as E from "fp-ts/lib/Either";
import { LocalDateTimeFromIsoStringC } from "../../codecs/localDate";
import { ContactFormSubmissionC as imported22_ContactFormSubmissionC, ContactFormSubmission as imported22_ContactFormSubmission, contactFormSubmissionC as imported22_contactFormSubmissionC } from "./contact";
import * as O from "fp-ts/lib/Option";
import { pipe } from "fp-ts/lib/function";
import * as Ord from "fp-ts/lib/Ord";
import { LocalDateTime } from "@js-joda/core";
import { RfpC as imported69_RfpC, Rfp as imported69_Rfp, rfpC as imported66_rfpC } from "./rfpBase";
import { OptionFromNullableC, optionFromNullable } from "io-ts-types/lib/optionFromNullable";
import * as RNEA from "fp-ts/lib/ReadonlyNonEmptyArray";
import { BondOfferingDetailsC as imported36_BondOfferingDetailsC, BondOfferingDetails as imported36_BondOfferingDetails, bondOfferingDetailsC as imported36_bondOfferingDetailsC } from "./bondOffering";
import { UserContentSubscriptionTypeCU as imported11_UserContentSubscriptionTypeCU, UserContentSubscriptionTypeU as imported5_UserContentSubscriptionTypeU, UserContentSubscriptionTypeCU as imported10_UserContentSubscriptionTypeCU } from "../domaintables/userContentSubscriptionTypes";
import { WithId as imported269_WithId, withModInfoC as imported246_withModInfoC, WithModInfo as imported246_WithModInfo, withIdC as imported269_withIdC, WithId as imported270_WithId, WithId as imported271_WithId, withModInfoC as imported245_withModInfoC, WithIdC as imported269_WithIdC, WithModInfoC as imported245_WithModInfoC, withIdC as imported271_withIdC, WithIdC as imported271_WithIdC, WithModInfo as imported245_WithModInfo, WithModInfoC as imported246_WithModInfoC, withIdC as imported270_withIdC, WithIdC as imported270_WithIdC } from "./threadThrough";
import { EmptyObjectC as imported0_EmptyObjectC, EmptyObject as imported0_EmptyObject, emptyObjectC as imported0_emptyObjectC } from "./emptyObject";
import { IpreoHoldingsC as imported13_IpreoHoldingsC, IpreoHoldings as imported13_IpreoHoldings, ipreoHoldingsC as imported13_ipreoHoldingsC } from "./ipreoHoldings";
import { ReadonlyNonEmptyArrayType, readonlyNonEmptyArrayC } from "../../codecs/readonlyNonEmptyArray";
import { Ord as stringOrd } from "fp-ts/lib/string";
import { Details as imported134_Details, detailsC as imported143_detailsC, Details as imported142_Details, detailsC as imported135_detailsC, Details as imported143_Details, Details as imported145_Details, detailsC as imported138_detailsC, DetailsC as imported134_DetailsC, detailsC as imported141_detailsC, Details as imported146_Details, DetailsC as imported133_DetailsC, TabCountC as imported13_TabCountC, DetailsC as imported145_DetailsC, detailsC as imported136_detailsC, DetailsC as imported139_DetailsC, Details as imported144_Details, DetailsC as imported137_DetailsC, DetailsC as imported141_DetailsC, detailsC as imported134_detailsC, DetailsC as imported146_DetailsC, DetailsC as imported143_DetailsC, detailsC as imported144_detailsC, tabCountC as imported14_tabCountC, detailsC as imported133_detailsC, Details as imported139_Details, DetailsC as imported135_DetailsC, Details as imported133_Details, TabCount as imported17_TabCount, TabCount as imported16_TabCount, Details as imported137_Details, DetailsC as imported140_DetailsC, detailsC as imported142_detailsC, Details as imported140_Details, Details as imported136_Details, TabCount as imported15_TabCount, DetailsC as imported144_DetailsC, detailsC as imported139_detailsC, TabCount as imported13_TabCount, Details as imported141_Details, tabCountC as imported16_tabCountC, DetailsC as imported136_DetailsC, DetailsC as imported138_DetailsC, TabCountC as imported14_TabCountC, detailsC as imported140_detailsC, tabCountC as imported15_tabCountC, DetailsC as imported142_DetailsC, detailsC as imported145_detailsC, detailsC as imported137_detailsC, tabCountC as imported13_tabCountC, Details as imported135_Details, TabCountC as imported17_TabCountC, detailsC as imported146_detailsC, TabCountC as imported16_TabCountC, Details as imported138_Details, TabCountC as imported15_TabCountC, TabCount as imported14_TabCount, tabCountC as imported17_tabCountC } from "./baseInvestorActivity";
import { ReadonlyMapFromEntriesC, readonlyMapFromEntries } from "io-ts-types/lib/readonlyMapFromEntries";
import { Ord as numberOrd } from "fp-ts/lib/number";
import { Actor as imported8_Actor, actorC as imported8_actorC, actorC as imported9_actorC, ActorC as imported8_ActorC, Actor as imported9_Actor, ActorC as imported9_ActorC } from "./actor";
import { MarkdownC, Markdown, markdownC } from "../../codecs/markdown";

export type DocumentC = t.TypeC<{
  id: t.NumberC,
  title: t.StringC,
  meta: imported0_EmptyObjectC
}>;
export type Document = {
  id: number,
  title: string,
  meta: imported0_EmptyObject
};
export const documentC: DocumentC = t.type({
  id: t.number,
  title: t.string,
  meta: imported0_emptyObjectC
}) satisfies t.Type<Document, unknown>;


export type EmailC = t.TypeC<{
  subject: t.StringC,
  meta: imported0_EmptyObjectC
}>;
export type Email = {
  subject: string,
  meta: imported0_EmptyObject
};
export const emailC: EmailC = t.type({
  subject: t.string,
  meta: imported0_emptyObjectC
}) satisfies t.Type<Email, unknown>;


export type RoadShowC = t.TypeC<{
  title: t.StringC,
  meta: imported0_EmptyObjectC
}>;
export type RoadShow = {
  title: string,
  meta: imported0_EmptyObject
};
export const roadShowC: RoadShowC = t.type({
  title: t.string,
  meta: imported0_emptyObjectC
}) satisfies t.Type<RoadShow, unknown>;


export type LinkC = t.TypeC<{
  name: t.StringC,
  description: OptionFromNullableC<MarkdownC>,
  meta: imported0_EmptyObjectC
}>;
export type Link = {
  name: string,
  description: O.Option<Markdown>,
  meta: imported0_EmptyObject
};
export const linkC: LinkC = t.type({
  name: t.string,
  description: optionFromNullable(markdownC),
  meta: imported0_emptyObjectC
}) satisfies t.Type<Link, unknown>;


export type PageC = t.TypeC<{
  title: t.StringC
}>;
export type Page = {
  title: string
};
export const pageC: PageC = t.type({
  title: t.string
}) satisfies t.Type<Page, unknown>;


export type NewsC = t.TypeC<{
  title: t.StringC
}>;
export type News = {
  title: string
};
export const newsC: NewsC = t.type({
  title: t.string
}) satisfies t.Type<News, unknown>;


export type ProjectC = t.TypeC<{
  title: t.StringC
}>;
export type Project = {
  title: string
};
export const projectC: ProjectC = t.type({
  title: t.string
}) satisfies t.Type<Project, unknown>;


export const sub = {
  _tag: `Sub`,
  name: `Sub`
} as const;

export type SubTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Sub`>
}>;
export const subTaggedC: SubTaggedC = t.type({
  _tag: t.literal(`Sub`)
});
export type SubTagged = t.TypeOf<SubTaggedC>;
export type Sub = SubTagged & typeof sub;
export type SubC = t.Type<Sub, SubTagged>;
export const subC: SubC = pipe(subTaggedC, c => new t.Type<Sub, SubTagged>(
  `Sub`,
  (u: unknown): u is Sub => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Sub> => pipe(c.decode(u), E.map(x => ({ ...x, ...sub }))),
  (x: Sub): SubTagged => ({ ...x, _tag: `Sub`}),
)) satisfies t.Type<Sub, unknown>;


export const unsub = {
  _tag: `Unsub`,
  name: `Unsub`
} as const;

export type UnsubTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Unsub`>
}>;
export const unsubTaggedC: UnsubTaggedC = t.type({
  _tag: t.literal(`Unsub`)
});
export type UnsubTagged = t.TypeOf<UnsubTaggedC>;
export type Unsub = UnsubTagged & typeof unsub;
export type UnsubC = t.Type<Unsub, UnsubTagged>;
export const unsubC: UnsubC = pipe(unsubTaggedC, c => new t.Type<Unsub, UnsubTagged>(
  `Unsub`,
  (u: unknown): u is Unsub => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Unsub> => pipe(c.decode(u), E.map(x => ({ ...x, ...unsub }))),
  (x: Unsub): UnsubTagged => ({ ...x, _tag: `Unsub`}),
)) satisfies t.Type<Unsub, unknown>;


export const allSubscriptionChangeC = [subC, unsubC] as const;
export const allSubscriptionChangeNames = [`Sub`, `Unsub`] as const;
export type SubscriptionChangeName = (typeof allSubscriptionChangeNames)[number];

export type SubscriptionChangeCU = t.UnionC<[SubC, UnsubC]>;
export type SubscriptionChangeU = Sub | Unsub;
export const SubscriptionChangeCU: SubscriptionChangeCU = t.union([subC, unsubC]) satisfies t.Type<SubscriptionChangeU, unknown>;

export const subscriptionChangeOrd: Ord.Ord<SubscriptionChangeU> = pipe(stringOrd, Ord.contramap(x => x._tag));
export const allSubscriptionChange = [sub, unsub] as const;
export type SubscriptionChangeMap<A> = { [K in SubscriptionChangeName]: A };


export type OfferingViewedC = t.TypeC<{
  _tag: t.LiteralC<`OfferingViewed`>,
  details: imported133_DetailsC,
  offering: imported269_WithIdC<imported245_WithModInfoC<imported36_BondOfferingDetailsC>>
}>;
export type OfferingViewed = {
  _tag: `OfferingViewed`,
  details: imported133_Details,
  offering: imported269_WithId<imported245_WithModInfo<imported36_BondOfferingDetails>>
};
export const offeringViewedC: OfferingViewedC = t.type({
  _tag: t.literal(`OfferingViewed`),
  details: imported133_detailsC,
  offering: imported269_withIdC(imported245_withModInfoC(imported36_bondOfferingDetailsC))
}) satisfies t.Type<OfferingViewed, unknown>;


export type RfpViewedC = t.TypeC<{
  _tag: t.LiteralC<`RfpViewed`>,
  details: imported134_DetailsC,
  rfp: imported270_WithIdC<imported246_WithModInfoC<imported69_RfpC>>
}>;
export type RfpViewed = {
  _tag: `RfpViewed`,
  details: imported134_Details,
  rfp: imported270_WithId<imported246_WithModInfo<imported69_Rfp>>
};
export const rfpViewedC: RfpViewedC = t.type({
  _tag: t.literal(`RfpViewed`),
  details: imported134_detailsC,
  rfp: imported270_withIdC(imported246_withModInfoC(imported66_rfpC))
}) satisfies t.Type<RfpViewed, unknown>;


export type ContactFormSubmittedC = t.TypeC<{
  _tag: t.LiteralC<`ContactFormSubmitted`>,
  details: imported135_DetailsC,
  submissionInfo: imported271_WithIdC<imported22_ContactFormSubmissionC>,
  meta: imported0_EmptyObjectC
}>;
export type ContactFormSubmitted = {
  _tag: `ContactFormSubmitted`,
  details: imported135_Details,
  submissionInfo: imported271_WithId<imported22_ContactFormSubmission>,
  meta: imported0_EmptyObject
};
export const contactFormSubmittedC: ContactFormSubmittedC = t.type({
  _tag: t.literal(`ContactFormSubmitted`),
  details: imported135_detailsC,
  submissionInfo: imported271_withIdC(imported22_contactFormSubmissionC),
  meta: imported0_emptyObjectC
}) satisfies t.Type<ContactFormSubmitted, unknown>;


export type RoadShowViewedC = t.TypeC<{
  _tag: t.LiteralC<`RoadShowViewed`>,
  details: imported136_DetailsC,
  roadShow: RoadShowC,
  furthestSeek: OptionFromNullableC<t.NumberC>
}>;
export type RoadShowViewed = {
  _tag: `RoadShowViewed`,
  details: imported136_Details,
  roadShow: RoadShow,
  furthestSeek: O.Option<number>
};
export const roadShowViewedC: RoadShowViewedC = t.type({
  _tag: t.literal(`RoadShowViewed`),
  details: imported136_detailsC,
  roadShow: roadShowC,
  furthestSeek: optionFromNullable(t.number)
}) satisfies t.Type<RoadShowViewed, unknown>;


export type LinkClickedC = t.TypeC<{
  _tag: t.LiteralC<`LinkClicked`>,
  details: imported137_DetailsC,
  link: LinkC
}>;
export type LinkClicked = {
  _tag: `LinkClicked`,
  details: imported137_Details,
  link: Link
};
export const linkClickedC: LinkClickedC = t.type({
  _tag: t.literal(`LinkClicked`),
  details: imported137_detailsC,
  link: linkC
}) satisfies t.Type<LinkClicked, unknown>;


export type SiteViewedC = t.TypeC<{
  _tag: t.LiteralC<`SiteViewed`>,
  details: imported138_DetailsC,
  pages: ReadonlyNonEmptyArrayType<PageC>
}>;
export type SiteViewed = {
  _tag: `SiteViewed`,
  details: imported138_Details,
  pages: RNEA.ReadonlyNonEmptyArray<Page>
};
export const siteViewedC: SiteViewedC = t.type({
  _tag: t.literal(`SiteViewed`),
  details: imported138_detailsC,
  pages: readonlyNonEmptyArrayC(pageC)
}) satisfies t.Type<SiteViewed, unknown>;


export type NewsViewedC = t.TypeC<{
  _tag: t.LiteralC<`NewsViewed`>,
  details: imported139_DetailsC,
  news: NewsC
}>;
export type NewsViewed = {
  _tag: `NewsViewed`,
  details: imported139_Details,
  news: News
};
export const newsViewedC: NewsViewedC = t.type({
  _tag: t.literal(`NewsViewed`),
  details: imported139_detailsC,
  news: newsC
}) satisfies t.Type<NewsViewed, unknown>;


export type ProjectViewedC = t.TypeC<{
  _tag: t.LiteralC<`ProjectViewed`>,
  details: imported140_DetailsC,
  project: ProjectC
}>;
export type ProjectViewed = {
  _tag: `ProjectViewed`,
  details: imported140_Details,
  project: Project
};
export const projectViewedC: ProjectViewedC = t.type({
  _tag: t.literal(`ProjectViewed`),
  details: imported140_detailsC,
  project: projectC
}) satisfies t.Type<ProjectViewed, unknown>;


export type EmailOpenedC = t.TypeC<{
  _tag: t.LiteralC<`EmailOpened`>,
  details: imported141_DetailsC,
  email: EmailC,
  receivedDate: LocalDateTimeFromIsoStringC
}>;
export type EmailOpened = {
  _tag: `EmailOpened`,
  details: imported141_Details,
  email: Email,
  receivedDate: LocalDateTime
};
export const emailOpenedC: EmailOpenedC = t.type({
  _tag: t.literal(`EmailOpened`),
  details: imported141_detailsC,
  email: emailC,
  receivedDate: LocalDateTimeFromIsoStringC
}) satisfies t.Type<EmailOpened, unknown>;


export type EmailLinkClickedC = t.TypeC<{
  _tag: t.LiteralC<`EmailLinkClicked`>,
  details: imported142_DetailsC,
  email: EmailC,
  receivedDate: LocalDateTimeFromIsoStringC
}>;
export type EmailLinkClicked = {
  _tag: `EmailLinkClicked`,
  details: imported142_Details,
  email: Email,
  receivedDate: LocalDateTime
};
export const emailLinkClickedC: EmailLinkClickedC = t.type({
  _tag: t.literal(`EmailLinkClicked`),
  details: imported142_detailsC,
  email: emailC,
  receivedDate: LocalDateTimeFromIsoStringC
}) satisfies t.Type<EmailLinkClicked, unknown>;


export type EmailReceivedC = t.TypeC<{
  _tag: t.LiteralC<`EmailReceived`>,
  details: imported143_DetailsC,
  email: EmailC
}>;
export type EmailReceived = {
  _tag: `EmailReceived`,
  details: imported143_Details,
  email: Email
};
export const emailReceivedC: EmailReceivedC = t.type({
  _tag: t.literal(`EmailReceived`),
  details: imported143_detailsC,
  email: emailC
}) satisfies t.Type<EmailReceived, unknown>;


export type DocumentDownloadedC = t.TypeC<{
  _tag: t.LiteralC<`DocumentDownloaded`>,
  details: imported144_DetailsC,
  document: DocumentC
}>;
export type DocumentDownloaded = {
  _tag: `DocumentDownloaded`,
  details: imported144_Details,
  document: Document
};
export const documentDownloadedC: DocumentDownloadedC = t.type({
  _tag: t.literal(`DocumentDownloaded`),
  details: imported144_detailsC,
  document: documentC
}) satisfies t.Type<DocumentDownloaded, unknown>;


export type DocumentViewedC = t.TypeC<{
  _tag: t.LiteralC<`DocumentViewed`>,
  details: imported145_DetailsC,
  document: DocumentC
}>;
export type DocumentViewed = {
  _tag: `DocumentViewed`,
  details: imported145_Details,
  document: Document
};
export const documentViewedC: DocumentViewedC = t.type({
  _tag: t.literal(`DocumentViewed`),
  details: imported145_detailsC,
  document: documentC
}) satisfies t.Type<DocumentViewed, unknown>;


export type NotificationSubscriptionsChangedC = t.TypeC<{
  _tag: t.LiteralC<`NotificationSubscriptionsChanged`>,
  details: imported146_DetailsC,
  subscriptions: ReadonlyNonEmptyArrayType<SubscriptionChangeCU>
}>;
export type NotificationSubscriptionsChanged = {
  _tag: `NotificationSubscriptionsChanged`,
  details: imported146_Details,
  subscriptions: RNEA.ReadonlyNonEmptyArray<SubscriptionChangeU>
};
export const notificationSubscriptionsChangedC: NotificationSubscriptionsChangedC = t.type({
  _tag: t.literal(`NotificationSubscriptionsChanged`),
  details: imported146_detailsC,
  subscriptions: readonlyNonEmptyArrayC(SubscriptionChangeCU)
}) satisfies t.Type<NotificationSubscriptionsChanged, unknown>;


export const allInvestorActivityTabC = [offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, linkClickedC, siteViewedC, newsViewedC, projectViewedC, emailOpenedC, emailLinkClickedC, emailReceivedC, documentDownloadedC, documentViewedC, notificationSubscriptionsChangedC] as const;
export const allInvestorActivityTabNames = [`OfferingViewed`, `RfpViewed`, `ContactFormSubmitted`, `RoadShowViewed`, `LinkClicked`, `SiteViewed`, `NewsViewed`, `ProjectViewed`, `EmailOpened`, `EmailLinkClicked`, `EmailReceived`, `DocumentDownloaded`, `DocumentViewed`, `NotificationSubscriptionsChanged`] as const;
export type InvestorActivityTabName = (typeof allInvestorActivityTabNames)[number];

export type InvestorActivityTabCU = t.UnionC<[OfferingViewedC, RfpViewedC, ContactFormSubmittedC, RoadShowViewedC, LinkClickedC, SiteViewedC, NewsViewedC, ProjectViewedC, EmailOpenedC, EmailLinkClickedC, EmailReceivedC, DocumentDownloadedC, DocumentViewedC, NotificationSubscriptionsChangedC]>;
export type InvestorActivityTabU = OfferingViewed | RfpViewed | ContactFormSubmitted | RoadShowViewed | LinkClicked | SiteViewed | NewsViewed | ProjectViewed | EmailOpened | EmailLinkClicked | EmailReceived | DocumentDownloaded | DocumentViewed | NotificationSubscriptionsChanged;
export const InvestorActivityTabCU: InvestorActivityTabCU = t.union([offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, linkClickedC, siteViewedC, newsViewedC, projectViewedC, emailOpenedC, emailLinkClickedC, emailReceivedC, documentDownloadedC, documentViewedC, notificationSubscriptionsChangedC]) satisfies t.Type<InvestorActivityTabU, unknown>;

export type InvestorActivityTabMap<A> = { [K in InvestorActivityTabName]: A };


export const allNotificationActivityC = [notificationSubscriptionsChangedC] as const;
export const allNotificationActivityNames = [`NotificationSubscriptionsChanged`] as const;
export type NotificationActivityName = (typeof allNotificationActivityNames)[number];

export type NotificationActivityCU = NotificationSubscriptionsChangedC;
export type NotificationActivityU = NotificationSubscriptionsChanged;
export const NotificationActivityCU: NotificationActivityCU = notificationSubscriptionsChangedC satisfies t.Type<NotificationActivityU, unknown>;

export type NotificationActivityMap<A> = { [K in NotificationActivityName]: A };


export const allSiteActivityC = [offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, linkClickedC, siteViewedC, newsViewedC, projectViewedC] as const;
export const allSiteActivityNames = [`OfferingViewed`, `RfpViewed`, `ContactFormSubmitted`, `RoadShowViewed`, `LinkClicked`, `SiteViewed`, `NewsViewed`, `ProjectViewed`] as const;
export type SiteActivityName = (typeof allSiteActivityNames)[number];

export type SiteActivityCU = t.UnionC<[OfferingViewedC, RfpViewedC, ContactFormSubmittedC, RoadShowViewedC, LinkClickedC, SiteViewedC, NewsViewedC, ProjectViewedC]>;
export type SiteActivityU = OfferingViewed | RfpViewed | ContactFormSubmitted | RoadShowViewed | LinkClicked | SiteViewed | NewsViewed | ProjectViewed;
export const SiteActivityCU: SiteActivityCU = t.union([offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, linkClickedC, siteViewedC, newsViewedC, projectViewedC]) satisfies t.Type<SiteActivityU, unknown>;

export type SiteActivityMap<A> = { [K in SiteActivityName]: A };


export const allEmailActivityC = [emailOpenedC, emailLinkClickedC, emailReceivedC] as const;
export const allEmailActivityNames = [`EmailOpened`, `EmailLinkClicked`, `EmailReceived`] as const;
export type EmailActivityName = (typeof allEmailActivityNames)[number];

export type EmailActivityCU = t.UnionC<[EmailOpenedC, EmailLinkClickedC, EmailReceivedC]>;
export type EmailActivityU = EmailOpened | EmailLinkClicked | EmailReceived;
export const EmailActivityCU: EmailActivityCU = t.union([emailOpenedC, emailLinkClickedC, emailReceivedC]) satisfies t.Type<EmailActivityU, unknown>;

export type EmailActivityMap<A> = { [K in EmailActivityName]: A };


export const allDocumentActivityC = [documentDownloadedC, documentViewedC] as const;
export const allDocumentActivityNames = [`DocumentDownloaded`, `DocumentViewed`] as const;
export type DocumentActivityName = (typeof allDocumentActivityNames)[number];

export type DocumentActivityCU = t.UnionC<[DocumentDownloadedC, DocumentViewedC]>;
export type DocumentActivityU = DocumentDownloaded | DocumentViewed;
export const DocumentActivityCU: DocumentActivityCU = t.union([documentDownloadedC, documentViewedC]) satisfies t.Type<DocumentActivityU, unknown>;

export type DocumentActivityMap<A> = { [K in DocumentActivityName]: A };


export const allInvestorActivityC = [documentDownloadedC, documentViewedC, offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, emailOpenedC, emailLinkClickedC, linkClickedC, notificationSubscriptionsChangedC, siteViewedC, newsViewedC, projectViewedC, emailReceivedC] as const;
export const allInvestorActivityNames = [`DocumentDownloaded`, `DocumentViewed`, `OfferingViewed`, `RfpViewed`, `ContactFormSubmitted`, `RoadShowViewed`, `EmailOpened`, `EmailLinkClicked`, `LinkClicked`, `NotificationSubscriptionsChanged`, `SiteViewed`, `NewsViewed`, `ProjectViewed`, `EmailReceived`] as const;
export type InvestorActivityName = (typeof allInvestorActivityNames)[number];

export type InvestorActivityCU = t.UnionC<[DocumentDownloadedC, DocumentViewedC, OfferingViewedC, RfpViewedC, ContactFormSubmittedC, RoadShowViewedC, EmailOpenedC, EmailLinkClickedC, LinkClickedC, NotificationSubscriptionsChangedC, SiteViewedC, NewsViewedC, ProjectViewedC, EmailReceivedC]>;
export type InvestorActivityU = DocumentDownloaded | DocumentViewed | OfferingViewed | RfpViewed | ContactFormSubmitted | RoadShowViewed | EmailOpened | EmailLinkClicked | LinkClicked | NotificationSubscriptionsChanged | SiteViewed | NewsViewed | ProjectViewed | EmailReceived;
export const InvestorActivityCU: InvestorActivityCU = t.union([documentDownloadedC, documentViewedC, offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, emailOpenedC, emailLinkClickedC, linkClickedC, notificationSubscriptionsChangedC, siteViewedC, newsViewedC, projectViewedC, emailReceivedC]) satisfies t.Type<InvestorActivityU, unknown>;

export type InvestorActivityMap<A> = { [K in InvestorActivityName]: A };


export const allNonEmailSendActivityC = [documentDownloadedC, documentViewedC, offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, emailOpenedC, emailLinkClickedC, linkClickedC, notificationSubscriptionsChangedC, siteViewedC, newsViewedC, projectViewedC] as const;
export const allNonEmailSendActivityNames = [`DocumentDownloaded`, `DocumentViewed`, `OfferingViewed`, `RfpViewed`, `ContactFormSubmitted`, `RoadShowViewed`, `EmailOpened`, `EmailLinkClicked`, `LinkClicked`, `NotificationSubscriptionsChanged`, `SiteViewed`, `NewsViewed`, `ProjectViewed`] as const;
export type NonEmailSendActivityName = (typeof allNonEmailSendActivityNames)[number];

export type NonEmailSendActivityCU = t.UnionC<[DocumentDownloadedC, DocumentViewedC, OfferingViewedC, RfpViewedC, ContactFormSubmittedC, RoadShowViewedC, EmailOpenedC, EmailLinkClickedC, LinkClickedC, NotificationSubscriptionsChangedC, SiteViewedC, NewsViewedC, ProjectViewedC]>;
export type NonEmailSendActivityU = DocumentDownloaded | DocumentViewed | OfferingViewed | RfpViewed | ContactFormSubmitted | RoadShowViewed | EmailOpened | EmailLinkClicked | LinkClicked | NotificationSubscriptionsChanged | SiteViewed | NewsViewed | ProjectViewed;
export const NonEmailSendActivityCU: NonEmailSendActivityCU = t.union([documentDownloadedC, documentViewedC, offeringViewedC, rfpViewedC, contactFormSubmittedC, roadShowViewedC, emailOpenedC, emailLinkClickedC, linkClickedC, notificationSubscriptionsChangedC, siteViewedC, newsViewedC, projectViewedC]) satisfies t.Type<NonEmailSendActivityU, unknown>;

export type NonEmailSendActivityMap<A> = { [K in NonEmailSendActivityName]: A };


export type ActivitiesC = t.TypeC<{
  visitedSite: t.NumberC,
  viewedOffering: t.NumberC,
  viewedRfp: t.NumberC,
  viewedRoadshow: t.NumberC,
  downloadedDocument: ReadonlyMapFromEntriesC<t.NumberC, t.NumberC>,
  viewedDocument: t.NumberC,
  submittedContactForm: t.NumberC,
  subscribedToNotifications: t.NumberC,
  subscribedToEvents: t.NumberC,
  subscribedToBonds: t.NumberC,
  subscribedToRfps: t.NumberC,
  subscribedToDocs: t.NumberC,
  subscribedToNews: t.NumberC,
  subscribedToRatings: t.NumberC,
  receivedEmail: t.NumberC,
  openedEmail: t.NumberC,
  clickedEmail: t.NumberC,
  clickedLink: t.NumberC,
  didAnythingOtherThanEmailAction: t.NumberC
}>;
export type Activities = {
  visitedSite: number,
  viewedOffering: number,
  viewedRfp: number,
  viewedRoadshow: number,
  downloadedDocument: ReadonlyMap<number, number>,
  viewedDocument: number,
  submittedContactForm: number,
  subscribedToNotifications: number,
  subscribedToEvents: number,
  subscribedToBonds: number,
  subscribedToRfps: number,
  subscribedToDocs: number,
  subscribedToNews: number,
  subscribedToRatings: number,
  receivedEmail: number,
  openedEmail: number,
  clickedEmail: number,
  clickedLink: number,
  didAnythingOtherThanEmailAction: number
};
export const activitiesC: ActivitiesC = t.type({
  visitedSite: t.number,
  viewedOffering: t.number,
  viewedRfp: t.number,
  viewedRoadshow: t.number,
  downloadedDocument: readonlyMapFromEntries(t.number, numberOrd, t.number),
  viewedDocument: t.number,
  submittedContactForm: t.number,
  subscribedToNotifications: t.number,
  subscribedToEvents: t.number,
  subscribedToBonds: t.number,
  subscribedToRfps: t.number,
  subscribedToDocs: t.number,
  subscribedToNews: t.number,
  subscribedToRatings: t.number,
  receivedEmail: t.number,
  openedEmail: t.number,
  clickedEmail: t.number,
  clickedLink: t.number,
  didAnythingOtherThanEmailAction: t.number
}) satisfies t.Type<Activities, unknown>;


export type TabCountsC = t.TypeC<{
  all: imported13_TabCountC<imported0_EmptyObjectC>,
  site: imported14_TabCountC<SiteActivityCU>,
  email: imported15_TabCountC<EmailActivityCU>,
  document: imported16_TabCountC<DocumentActivityCU>,
  notification: imported17_TabCountC<NotificationActivityCU>
}>;
export type TabCounts = {
  all: imported13_TabCount<imported0_EmptyObject>,
  site: imported14_TabCount<SiteActivityU>,
  email: imported15_TabCount<EmailActivityU>,
  document: imported16_TabCount<DocumentActivityU>,
  notification: imported17_TabCount<NotificationActivityU>
};
export const tabCountsC: TabCountsC = t.type({
  all: imported13_tabCountC(imported0_emptyObjectC),
  site: imported14_tabCountC(SiteActivityCU),
  email: imported15_tabCountC(EmailActivityCU),
  document: imported16_tabCountC(DocumentActivityCU),
  notification: imported17_tabCountC(NotificationActivityCU)
}) satisfies t.Type<TabCounts, unknown>;


export type InvestorProfileInfoC = t.TypeC<{
  actor: imported8_ActorC,
  notificationSubscriptions: t.ReadonlyArrayC<imported11_UserContentSubscriptionTypeCU>,
  investorActivities: t.ReadonlyArrayC<InvestorActivityCU>,
  tabCounts: TabCountsC,
  holdings: t.ReadonlyArrayC<imported13_IpreoHoldingsC>
}>;
export type InvestorProfileInfo = {
  actor: imported8_Actor,
  notificationSubscriptions: ReadonlyArray<imported5_UserContentSubscriptionTypeU>,
  investorActivities: ReadonlyArray<InvestorActivityU>,
  tabCounts: TabCounts,
  holdings: ReadonlyArray<imported13_IpreoHoldings>
};
export const investorProfileInfoC: InvestorProfileInfoC = t.type({
  actor: imported8_actorC,
  notificationSubscriptions: t.readonlyArray(imported10_UserContentSubscriptionTypeCU),
  investorActivities: t.readonlyArray(InvestorActivityCU),
  tabCounts: tabCountsC,
  holdings: t.readonlyArray(imported13_ipreoHoldingsC)
}) satisfies t.Type<InvestorProfileInfo, unknown>;


export type InvestorActivityRowC = t.TypeC<{
  actor: imported9_ActorC,
  activities: ActivitiesC,
  lastActive: LocalDateTimeFromIsoStringC
}>;
export type InvestorActivityRow = {
  actor: imported9_Actor,
  activities: Activities,
  lastActive: LocalDateTime
};
export const investorActivityRowC: InvestorActivityRowC = t.type({
  actor: imported9_actorC,
  activities: activitiesC,
  lastActive: LocalDateTimeFromIsoStringC
}) satisfies t.Type<InvestorActivityRow, unknown>;


export type InvestorActivityTableC = t.TypeC<{
  investorActivityRows: t.ReadonlyArrayC<InvestorActivityRowC>
}>;
export type InvestorActivityTable = {
  investorActivityRows: ReadonlyArray<InvestorActivityRow>
};
export const investorActivityTableC: InvestorActivityTableC = t.type({
  investorActivityRows: t.readonlyArray(investorActivityRowC)
}) satisfies t.Type<InvestorActivityTable, unknown>;


